
import {PluginListenerHandle, registerPlugin} from "@capacitor/core";

export interface SafeAreaPlugin {
  addListener(event: 'safeAreaChanged', listener: (data: { bottom: number }) => void): Promise<PluginListenerHandle>;
}

const SafeArea = registerPlugin<SafeAreaPlugin>('SafeArea');

export default SafeArea;
